// extracted by mini-css-extract-plugin
export default {"contentContainer":"CreateContent_contentContainer__WRyAI","calculateBtnContainer":"CreateContent_calculateBtnContainer__Cj+ne"};